import React from 'react';
import { Badge } from '@/components/ui/badge';

interface RatingBadgeProps {
  rating: number;
  delta?: number | null;
  size?: 'sm' | 'md' | 'lg';
}

export function RatingBadge({ rating, delta, size = 'sm' }: RatingBadgeProps) {
  const deltaStr =
    delta != null && delta !== 0
      ? delta > 0
        ? `+${delta.toFixed(0)}`
        : `${delta.toFixed(0)}`
      : null;

  return (
    <span className="inline-flex items-center gap-1.5">
      <Badge variant="outline" size={size}>
        {Number(rating).toFixed(0)}
      </Badge>
      {deltaStr && (
        <span className={`text-xs ${delta! > 0 ? 'text-success' : 'text-danger'}`}>{deltaStr}</span>
      )}
    </span>
  );
}
